module.exports = require(30).PassThrough
